import { Component } from '@angular/core';
import { PermissionHandlerService } from 'src/app/services/permission-handler.service';
import { PermissionLoaderService } from 'src/app/services/permission-loader.service';
import { DataService } from 'src/app/services/data.service';
import { GlobalConstants } from 'src/app/services/global-constants';
import { MessagesModule } from 'primeng/messages';
import { MessageService } from 'primeng/api/messageservice';
import { TranslatorPipe } from 'src/app/services/translator.pipe';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent {

  licenseOus: any;
  staticURL = GlobalConstants.staticFilesURL;
  loading: boolean = false;
  isLoggedIn =  JSON.parse(localStorage.getItem('isLoggedIn') || "false");
  showAnnouncement = false;
  announcements: any;
  assessment: any;
  closable = true;

    //Popup messages
    messages: any[] = [];
    ignoreCount: number = 0;
startQuiz = false;

  constructor(
    public permissionService: PermissionHandlerService,
    private permissionLoader: PermissionLoaderService,
    private dataService: DataService,
  ) { }

  translate(key: string) {
    let translator: TranslatorPipe = new TranslatorPipe();
    return translator.transform(key);
  }

  hasContentDefaultPermisssion() {
    console.log(this.permissionService.payload.content.allow)
    return this.permissionService.payload.content.allow
  }

  reloadPage() {
    window.location.href = '/home';
  }

  ngOnInit() {
    let JustLoggedIn = localStorage.getItem('JustLoggedIn');

    if(JustLoggedIn == 'Yes') {
      localStorage.setItem('JustLoggedIn','No');

      this.reloadPage();
    }
    this.getAllActive();
    

    console.log("IS LOGGGED IN!!!", this.isLoggedIn);
    console.log("HAS PERMISSION", (!this.isLoggedIn && this.hasContentDefaultPermisssion()))
    this.permissionLoader.getState().subscribe(e => {
      this.loading = e;
    })
  }

  getAllActive = async () => {
    try {
      const res = await this.dataService.getData('announcement/allActive');
      console.log("annoucement ran")
      if (res.error) {
        return;
      }
      console.log("res",res);
      if (res.data.length > 0)
      {
        this.announcements = res.data[0];
        this.showAnnouncement = true;
        if(this.announcements.assessmentId) {
          let assessmentRes = await this.dataService.getData(
            `assessment/id/${this.announcements.assessmentId}`
          );

          if (!assessmentRes.error) {
            this.populateAssessment(assessmentRes.data);
          }
        }
      }
      console.log("this.announcements",this.announcements);
    } catch (error) {
    }
  };

  populateAssessment(data: any) {
    console.log("assessment adata", data)
    this.announcements.image = data.headerImage;
    // this.announcements.description = data.comments;
    this.ignoreCount = 0;

    this.announcements.ignoredBy.forEach((id: string) => {
      if(id == localStorage.getItem('uid')){
        this.ignoreCount++;
      }
    });

    if(this.announcements?.ignoreLimit && this.ignoreCount > this.announcements?.ignoreLimit) {
      this.closable = false;
    }

    this.assessment = data;
  }

  async assessmentSubmit() {
    let email = localStorage.getItem('email');
    if (email) {
      this.assessment.email = email;
    }

    // Check if any question has an empty meta.value
    let unanswered = this.assessment.questions.some((q: any) => q.meta?.value === "");

    if (unanswered) {
      this.messages = [
        {
          severity: 'error',
          summary: this.translate('All questions not answered'),
          detail: this.translate("Please answer all questions")
        }
      ];
      return; // Stop further execution
    }


    

    let res = await this.dataService.postData(
      `assessment/submit`,
      this.assessment
    );

    if (res.error) {
      return;
    } else {
      this.generateAssessmentResults();
      this.showAnnouncement = false;

    }
  }

  async generateAssessmentResults() {
    try {
      let res = await this.dataService.postData(
        `assessment-result/generate`,
        ''
      );
      let res2 = await this.dataService.postData('announcement/UpdateSeenBy/' + this.announcements._id,null,'POST',false);
    } catch (e) {}
  }

  setAnnouncementSeenBy = async (id: string) => {
        try {
          if(!this.announcements.assessmentId) {
            let res = await this.dataService.postData('announcement/UpdateSeenBy/' + id,null,'POST',false);
          } else {
            let res = await this.dataService.postData('announcement/UpdateIgnoredBy/' + id,null,'POST',false);
          }
        } catch (error) {
          console.log(error);
        }
    };
}
